<template>
	<li
		class="post_tile"
		@mouseover="hover = true"
		@mouseleave="hover = false"
		:class="[this.background_colour, this.mode, this.index, { 'featured': isFeatured() }]"
		:style="{'--gradient': 'url(' + gradient + ')' }"
	>
		<div
			v-if='video && video.video_url != "" || video && video.video_file != ""'
			class="tile-image"
			:style="{
        '--gallery-background': 'url(' + image + ')',
      }"
			:class="{
        hover: hover === true,
      }"
		>
			<video-modal
				v-if='video && video.video_url != "" || video && video.video_file != ""'
				:has_border="'no'"
				:video_poster="image"
				:video_source="(video.video_url || video.video_file) ? (video.video_url || video.video_file.url) : false"
			></video-modal>

		</div>

		<a
			v-else
			:href="this.mode == 'content' ? null : extractUrl(permalink)"
			class="tile-image"
			:style="{
        '--gallery-background': 'url(' + image + ')',
      }"
			:class="{
        hover: hover === true,
      }"
		>
			<img
				:src="image ? image : fallBack"
				:alt="name"
				:class="{'fallback': fallBack}"
			/>

		</a>

		<a
			:href="this.mode == 'content' ? null : extractUrl(permalink)"
			class="content"
		>
			<div class="upper">

				<div
					class="date_n_tag"
					:class="this.index"
				>

					<label
						v-for="(tag_item, index) in tag"
						:key="index"
						:class="tag_item.slug"
						v-html="tag_item.name != 'Uncategorised' ? tag_item.name : null"
					></label>

					<div
						class='date'
						v-html="date"
					></div>
				</div>

				<h4
					:class="this.index"
					v-html="name"
				></h4>

				<span
					class="subtitle"
					:class="this.index"
					v-html="short_description"
				></span>
			</div>
			<div class="lower">
				<primary-button
					v-if='extractUrl(permalink)'
					:link="extractUrl(permalink)"
					:label="'Learn More'"
					:theme="'post'"
				></primary-button>
			</div>
		</a>
		<slot></slot>
	</li>
</template>

<script>
import Arrow from '../../images/arrow-long.svg';
import PrimaryButton from './PrimaryButton.vue';
import FallBack from '../../images/shield.svg';
import VideoModal from './VideoModal.vue';
import Gradient from '../../images/Duco_Gradient.jpg';

export default {
	data() {
		return {
			hover: false,
			arrow: Arrow,
			fallBack: FallBack,
			gradient: Gradient,
		};
	},

	props: {
		name: {},
		permalink: {},
		short_description: {},
		image: {},
		tag: {},
		background_colour: {
			default: 'light-stone',
		},
		mode: {
			default: 'news',
		},
		arrow_colour: {
			default: 'gold',
		},
		index: {},
		video: {},
		date: {},
	},

	computed: {},

	watch: {},

	methods: {
		toTitleCase(str) {
			return str.replace(/-/g, ' ').replace(/\w\S*/g, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		},

		isFeatured() {
			return this.tag.some(
				(tagItem) => tagItem.name.toLowerCase() === 'featured',
			);
		},

		extractUrl(permalink) {
			if (typeof permalink === 'string') {
				// Check if it's a non-empty string
				return permalink !== '' ? permalink : null;
			} else if (typeof permalink === 'object' && permalink !== null) {
				// Check if it's an object with a 'url' property
				return permalink.url || null;
			} else {
				// Handle other cases or return a default value as needed
				return null;
			}
		},
	},

	components: {
		PrimaryButton,
		VideoModal,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.post_tile {
	overflow: hidden;
	grid-column: span 3;
	display: grid;
	grid-template-rows: auto 1fr;
	position: relative;

	@media (max-width: $tablet) and (orientation: portrait) {
		grid-column: span 3;
	}

	@media (max-width: $mobile-xl) {
		grid-column: span 4;
		grid-template-rows: auto 1fr;
		display: flex;
	}

	&.post,
	&.page {
		a {
			&.tile-image {
				aspect-ratio: 2 / 1;

				@media (max-width: $mobile-xl) {
					aspect-ratio: 2 / 1;
				}
			}
		}
	}

	/* &.featured_post {
		.site_button_secondary {
			&::v-deep {
				span {
					display: none;
				}
			}
		}
	} */

	&.featured {
		position: relative;

		.featured_post_listing &,
		.post_tiles & {
			overflow: visible;

			.tile-image {
				margin-left: -50px;
			}

			&::before {
				content: 'Featured';
				background-image: var(--gradient);
				background-repeat: no-repeat;
				background-position: center center;
				background-size: cover;
				color: white;
				position: absolute;
				height: 50px;
				width: 125px;
				top: 0;
				left: 0;
				z-index: 10;
				border-radius: 10px;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
	}

	a,
	div {
		&.tile-image {
			display: flex;
			/* aspect-ratio: 300 / 250; */
			overflow: hidden;
			transition: 0.2s ease all;
			position: relative;
			text-decoration: none;

			@media (max-width: $mobile) {
				height: auto;
			}

			.video {
				aspect-ratio: 2 / 1;
			}

			&.hover {
				img:not(.page) {
					transition: 0.2s ease all;
					transform: scale(1.1);
				}
			}

			> span {
				width: 100%;
			}

			img:not(.page) {
				width: 100%;
				height: 100%;
				object-fit: cover;
				position: relative;
				transition: 0.2s ease all;
				transform: scale(1);
				aspect-ratio: 2 / 1;
			}

			.tag_container {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				position: relative;
				z-index: 10;
				position: absolute;
				bottom: 10px;
				right: 10px;
				margin: 0;
				gap: 7px;
				justify-content: flex-end;

				label {
					font: normal normal normal 14px/20px var(--primary-font-family);
					background: var(--chartruese-green);
					color: var(--black);
					border-radius: 15px;
					text-decoration: none;
					padding: 5px 10px;
					height: fit-content;

					@media (max-width: $mobile-xl) {
						margin-bottom: 0;
					}
				}
			}

			/* &.page {
				justify-content: center;
				align-items: center;
				background: var(--black);

				&:hover {
					img {
						width: 120px;
						transition: 0.2s ease all;
					}
				}

				
			} */

			/* img {
				width: 100px;
				height: auto;
				transition: 0.2s ease all;

				&.fallback {
					object-fit: contain;
					width: 200px;
					opacity: 0.3;
				}
			} */
		}
	}

	.content {
		padding: 30px 0;
		background-color: white;
		transition: 0.2s ease all;
		height: calc(100% - 44px);
		width: calc(100% - 44px);
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		row-gap: 24px;
		text-decoration: none;
		color: var(--black);

		@media (max-width: $mobile-xl) {
			height: unset;
		}

		.upper {
			width: 100%;

			.date_n_tag {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				gap: 10px;

				.date {
					font: normal normal normal 16px/24px var(--primary-font-family);
				}

				label {
					font: normal normal normal 16px/24px var(--primary-font-family);
					color: var(--duco-blue);
					text-transform: uppercase;
					display: flex;
					justify-content: center;

					&:not(:last-of-type) {
						&::after {
							content: '';
							display: inline-flex;
							width: 2px;
							height: 20px;
							background: var(--duco-blue);
							margin-left: 12px;
							margin-right: 0;
						}
					}
				}

				&.featured {
					.date {
						@media (min-width: $mobile-xl) {
							font: normal normal normal 27px/34px var(--primary-font-family);
						}
					}

					label {
						@media (min-width: $mobile-xl) {
							font: normal normal normal 27px/34px var(--primary-font-family);
						}
					}
				}
			}

			h4 {
				/* font: normal normal 600 18px/24px var(--primary-font-family); */
				margin: 5px 0 10px;
				text-transform: capitalize;

				&.featured {
					margin: 15px 0 30px;

					@media (min-width: $mobile-xl) {
						font: normal normal 300 33px/36px var(--primary-font-family);
					}
				}
			}

			.subtitle {
				margin: 20px 0 0;

				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				overflow: hidden;

				&.featured {
					@media (min-width: $mobile-xl) {
						font: normal normal 300 26px/30px var(--primary-font-family);
					}
				}

				&::v-deep {
					p {
						margin: 0;
						font: normal normal normal 15px/24px var(--primary-font-family);
					}
				}
			}
		}

		.lower {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;

			.site_button_secondary {
				&::v-deep {
					&:hover {
						cursor: pointer;
					}
				}
			}

			.attributes {
				display: flex;
				flex-direction: row;
				align-items: center;
				gap: 5px;
				text-transform: uppercase;
			}
		}
	}

	/* &.nexty {
		.content {
			.lower {
				.site_button_secondary {
					pointer-events: none;

					&::v-deep {
						&:hover {
							cursor: unset;
							span {
								text-decoration: none;
							}
						}
					}
				}
			}
		}
	} */
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PostTile.vue